import * as Yup from "yup";
import {
  validateExpressionConditionsRequired,
  validateRateLimitCharacteristics,
} from "./expressionValidators";
import { mapYupFlatErrors, runSchemaWithContext } from "./yupFormUtils";
import { blockMessageField, nameField } from "./yupCommonFields";

function isEmptyRateLimitConditions(conditions) {
  return (
    conditions?.length === 1 &&
    conditions[0]?.length === 1 &&
    (conditions[0][0]?.key === "none" || !conditions[0][0]?.key) &&
    (conditions[0][0]?.condition === "none" || !conditions[0][0]?.condition) &&
    !String(conditions[0][0]?.value ?? "").trim()
  );
}

function buildEmptyConditionErrors(conditions) {
  return (conditions || []).map((orCond) =>
    (orCond || []).map(() => ({ key: false, condition: false, value: false })),
  );
}

function buildEmptyCharacteristicErrors(characteristics) {
  return (characteristics || []).map(() => ({ key: false, value: false }));
}

const rateLimitRuleFormSchema = Yup.object({
  name: nameField,
  blockMessage: blockMessageField,
  conditions: Yup.array().test("conditions", function (conditions) {
    const conditionEmpty = isEmptyRateLimitConditions(conditions);
    this.options.context.conditionEmpty = conditionEmpty;

    if (conditionEmpty) {
      this.options.context.conditionErrors = buildEmptyConditionErrors(conditions);
      return true;
    }

    const condResult = validateExpressionConditionsRequired(conditions);
    this.options.context.conditionErrors = condResult.errors;

    if (!condResult.valid) {
      return this.createError({
        message: condResult.message || "Fix match condition errors",
        path: "conditions",
      });
    }
    return true;
  }),
  characteristics: Yup.array().test("characteristics", function (characteristics) {
    const charResult = validateRateLimitCharacteristics(characteristics);
    this.options.context.characteristicErrors = charResult.errors;

    if (!charResult.valid) {
      return this.createError({
        message: charResult.message || "Fix rate limit characteristics",
        path: "characteristics",
      });
    }
    return true;
  }),
});

export function validateRateLimitRuleForm({ name, conditions, characteristics, blockMessage }) {
  const context = {
    conditionEmpty: isEmptyRateLimitConditions(conditions),
    conditionErrors: buildEmptyConditionErrors(conditions),
    characteristicErrors: buildEmptyCharacteristicErrors(characteristics),
  };

  const result = runSchemaWithContext(
    rateLimitRuleFormSchema,
    { name, conditions, characteristics, blockMessage },
    context,
  );

  if (result.valid) {
    return {
      valid: true,
      formErrors: {},
      conditionErrors: context.conditionErrors,
      characteristicErrors: context.characteristicErrors,
      conditionEmpty: context.conditionEmpty,
    };
  }

  return {
    valid: false,
    formErrors: mapYupFlatErrors(result.err, ["name", "blockMessage", "conditions", "characteristics"]),
    conditionErrors: context.conditionErrors ?? buildEmptyConditionErrors(conditions),
    characteristicErrors: context.characteristicErrors ?? buildEmptyCharacteristicErrors(characteristics),
    conditionEmpty: context.conditionEmpty,
  };
}
